module.exports = __webpack_public_path__ + "static/img/bruxa.5d87600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bruxa.jpg
// module id = +OXp
// module chunks = 0